<fui-select-option *ngIf="allowClearSelectionOption && filled(filteredOptions)"
                   [clearSelectionOptionLabel]="(clearSelectionOptionLabel ? clearSelectionOptionLabel : 'fui.select-control.label.none') | translate"></fui-select-option>
<ng-container *ngFor="let option of extendedOptions">
    <div *ngIf="option.meta.groupHeading" class="group-heading">
        {{option.meta.groupHeading | translate}}
    </div>
    <fui-select-option [field]="field" [key]="key" [option]="option.data"
                       [optionOpenable]="optionOpenable" [attr.option-label]="option.data[key]"
                       [attr.option-value]="option.data[field]"
                       [icon]="option.meta.icon"
                       [optionElementHandler]="optionElementHandler"
                       (optionOpened$)="optionOpened$.emit($event)"></fui-select-option>
</ng-container>
